import { Icon, MarketplaceCards } from "@garantidos/components"

import { If } from "@mobi/components"
import { Alert } from "@mobi/ds"

import "./style.scss"

const Unqualified = ({
  unqualified,
  message,
  alertRef,
  handleUnqualifiedTracking
}) => (
  <div ref={alertRef} className="unqualifiedRecomendation">
    <If
      condition={unqualified && message}
      renderIf={
        <div className="error-alert" aria-live="assertive">
          <Alert
            paragraph={true}
            icon={<Icon icon="informação" />}
            fadeIn
            isVisible
            message={message}
            variant="offer"
          />
          <MarketplaceCards
            app="cgi"
            cards="emprestimo"
            marketplaceCallback={handleUnqualifiedTracking}
          />
        </div>
      }
    />
  </div>
)

export default Unqualified
